import { QueryClient, QueryClientConfig } from '@tanstack/react-query';
import { getDefaultStore } from 'jotai/vanilla';
import { queryClientAtom } from 'jotai-tanstack-query';

import { is403Error } from '@cast/api-client';

import { isE2E } from '@oneclick/utils/isE2E';

const clientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      gcTime: 20_000,
      retry: (failureCount, error: any) => {
        if (is403Error(error)) {
          return false;
        }
        if (isE2E()) {
          return false;
        }
        return failureCount < 4;
      },
    },
  },
};

export const queryClient = new QueryClient(clientConfig);

getDefaultStore().set(queryClientAtom, queryClient);
